import { useEffect, useRef, useState } from 'react';
import * as React from 'react';

import ExploreSubPage from 'bundles/composable-page-header/components/mobile-menu-items/ExploreSubPage';
import MobileBackNavHeader from 'bundles/composable-page-header/components/mobile-menu-items/MobileBackNavHeader';
import type { MobileExploreIdentifierValues } from 'bundles/composable-page-header/constants';
import { MegaMenuDataProviderWithHOC } from 'bundles/composable-page-header/providers/MegaMenuDataProvider';
import type { MenuItem } from 'bundles/megamenu/types/MenuData';

import _t from 'i18n!nls/composable-page-header';

type Props = {
  identifier: MobileExploreIdentifierValues;
};

export const ExploreCustomConsumerSubmenu = (props: Props) => {
  const { identifier } = props;
  const [exploreViewState, setExploreViewState] = useState<MobileExploreIdentifierValues>(identifier);
  const [currentMenuItem, setMenuItem] = useState<MenuItem | undefined>(undefined);
  const mobileBackBtnRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // When entering a subpage, focus on the back button so the page scrolls to the top
    if (mobileBackBtnRef.current instanceof HTMLElement) {
      mobileBackBtnRef.current.focus();
    }
  }, [currentMenuItem, mobileBackBtnRef]);

  return (
    <div>
      <ExploreSubPage
        exploreViewState={exploreViewState}
        setExploreViewState={setExploreViewState}
        setMenuItem={setMenuItem}
        currentMenuItem={currentMenuItem}
        backToExplore={
          <div ref={mobileBackBtnRef}>
            <MobileBackNavHeader
              label={_t('Main menu')}
              trackingName="mobile_header_back_to_explore_submenu_button"
              ariaLabel={_t('Go to Main menu navigation slide')}
              onClick={() => setExploreViewState(identifier)}
            />
          </div>
        }
      />
    </div>
  );
};

const WrappedExploreCustomConsumerSubmenu = (props: Props) => (
  <MegaMenuDataProviderWithHOC isEnterprise={false}>
    <ExploreCustomConsumerSubmenu {...props} />
  </MegaMenuDataProviderWithHOC>
);

export default WrappedExploreCustomConsumerSubmenu;
